// Global ResizeObserver error suppression
export const suppressResizeObserverErrors = () => {
  // Override ResizeObserver completely
  if (typeof window !== 'undefined') {
    const OriginalResizeObserver = window.ResizeObserver;
    
    window.ResizeObserver = class extends OriginalResizeObserver {
      constructor(callback) {
        super((entries, observer) => {
          window.requestAnimationFrame(() => {
            try {
              callback(entries, observer);
            } catch (error) {
              // Silently ignore all ResizeObserver errors
            }
          });
        });
      }
    };

    // Override console.error to filter ResizeObserver errors
    const originalConsoleError = console.error;
    console.error = function(...args) {
      const message = args[0];
      if (typeof message === 'string' && message.includes('ResizeObserver')) {
        return;
      }
      return originalConsoleError.apply(console, args);
    };
  }
};